import actions from '@/core/store/item-ata/transferencia/transferir/actions'
import state from '@/core/store/item-ata/transferencia/transferir/state'
import mutations from '@/core/store/item-ata/transferencia/transferir/mutations'

export default { actions, state, mutations }
